// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"e313218f","375":"4eabc3d1","388":"4a2609d6","827":"3cf9b458","842":"dc52eef4","860":"9c8accf5","984":"72bc1a42"}[chunkId] + ".chunk.js";
};